module.exports = __webpack_public_path__ + "media/images/icons/country_flags/pt-3504a4e41fe02a671a350927c3ef1180.svg";